import React, { useEffect } from 'react'
import FinesYesView from './components/FinesYesView'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const FinesYes = ({ i18n }) => {
  useEffect(() => {
    try {
      addToGoogleDataLayer('fines-yes', 'Pay for a Road Test', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return <FinesYesView />
}

export default withTranslation('common')(FinesYes)
